import { Routes } from '@angular/router';
import { Home } from './components/home/home';
import { ProductListComponent } from './components/product-list/product-list.component';
import { ProductDetail } from './components/product-detail/product-detail';
import { RecipeList } from './components/recipe-list/recipe-list';
import { RecipeDetail } from './components/recipe-detail/recipe-detail';
import { About } from './components/about/about';
import { Location } from './components/location/location';
import { Blog } from './components/blog/blog';
import { adminGuard } from './admin/admin.guard';
import { MaintenanceGuard } from './maintenance.guard';

export const routes: Routes = [
  // ── Maintenance page ──
  { path: 'maintenance', loadComponent: () => import('./components/maintenance/maintenance').then(m => m.MaintenanceComponent) },

  // ── Public pages ──
  { path: '', component: Home, canActivate: [MaintenanceGuard] },
  { path: 'products', component: ProductListComponent, canActivate: [MaintenanceGuard] },
  { path: 'products/:category', component: ProductListComponent, canActivate: [MaintenanceGuard] },
  { path: 'product/:id', component: ProductDetail, canActivate: [MaintenanceGuard] },
  { path: 'recipes', component: RecipeList, canActivate: [MaintenanceGuard] },
  { path: 'recipes/:id', component: RecipeDetail, canActivate: [MaintenanceGuard] },
  { path: 'our-story', component: About, canActivate: [MaintenanceGuard] },
  { path: 'location', component: Location, canActivate: [MaintenanceGuard] },
  { path: 'contact', loadComponent: () => import('./components/contact/contact').then(m => m.Contact), canActivate: [MaintenanceGuard] },
  { path: 'blog', component: Blog, canActivate: [MaintenanceGuard] },
  { path: 'blog/:id', loadComponent: () => import('./components/blog-detail/blog-detail').then(m => m.BlogDetail), canActivate: [MaintenanceGuard] },

  // ── Admin login (no guard) ──
  {
    path: 'admin/login',
    loadComponent: () =>
      import('./admin/admin-login/admin-login.component').then(m => m.AdminLoginComponent),
  },

  // ── Admin panel (protected) ──
  {
    path: 'admin',
    loadComponent: () =>
      import('./admin/admin-shell/admin-shell.component').then(m => m.AdminShellComponent),
    canActivate: [adminGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./admin/admin-dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent),
      },
      {
        path: 'products',
        loadComponent: () =>
          import('./admin/admin-products/admin-products.component').then(m => m.AdminProductsComponent),
      },
      {
        path: 'products/new',
        loadComponent: () =>
          import('./admin/admin-product-form/admin-product-form.component').then(m => m.AdminProductFormComponent),
      },
      {
        path: 'products/edit/:id',
        loadComponent: () =>
          import('./admin/admin-product-form/admin-product-form.component').then(m => m.AdminProductFormComponent),
      },
      {
        path: 'recipes',
        loadComponent: () =>
          import('./admin/admin-recipes/admin-recipes.component').then(m => m.AdminRecipesComponent),
      },
      {
        path: 'blog',
        loadComponent: () =>
          import('./admin/admin-blog/admin-blog.component').then(m => m.AdminBlogComponent),
      },
      {
        path: 'content',
        loadComponent: () =>
          import('./admin/admin-content/admin-content.component').then(m => m.AdminContentComponent),
      },
    ],
  },

  { path: '**', redirectTo: '' },
];
